import moment from 'moment-timezone'
import React, { useId } from 'react'

// Kalau `htmlFor` diisi, label tersambung ke inputnya: bisa diklik untuk
// fokus, dan namanya bisa dibaca lewat `input.labels` (dipakai pesan validasi
// di ManualRegistration).
export const FieldLabel = ({ label, labelTopRight, required, htmlFor }) => {
  if (!label && !labelTopRight) {
    return null
  }
  const LabelTag = htmlFor ? 'label' : 'span'
  return (
    <div className="flex items-center justify-between gap-2 mb-1.5">
      <LabelTag htmlFor={htmlFor} className="text-[13px] font-medium text-ink">
        {label}
        {required && <span className="text-[#E5484D]">*</span>}
      </LabelTag>
      <span className="text-[12px] text-muted">{labelTopRight}</span>
    </div>
  )
}

export const FieldHint = ({ labelBottomLeft, labelBottomRight }) => {
  if (!labelBottomLeft && !labelBottomRight) {
    return null
  }
  return (
    <div className="flex items-center justify-between gap-2 mt-1.5">
      <span className="text-[12px] text-[#F9813B]">{labelBottomLeft}</span>
      <span className="text-[12px] text-muted">{labelBottomRight}</span>
    </div>
  )
}

// Kelas dipakai bersama oleh input teks dan pembungkus editor markdown supaya
// tinggi, radius, dan warna fokusnya sama.
export const inputClass =
  'w-full h-10 rounded-xl border border-line bg-white px-3 text-sm text-ink placeholder:text-muted outline-none transition-colors focus:border-accent disabled:bg-subtle disabled:text-muted'

const TextInput = ({
  label,
  labelTopRight,
  labelBottomLeft,
  labelBottomRight,
  placeholder,
  type,
  name,
  required,
  disabled,
  defaultValue,
  inputMode,
  pattern,
  title,
  onInput,
}) => {
  const id = useId()
  return (
    <div className="w-full">
      <FieldLabel
        label={label}
        labelTopRight={labelTopRight}
        required={required}
        htmlFor={id}
      />
      <input
        id={id}
        name={name}
        type={type}
        placeholder={placeholder}
        className={inputClass}
        required={required}
        defaultValue={defaultValue}
        disabled={disabled}
        inputMode={inputMode}
        pattern={pattern}
        title={title}
        onInput={onInput}
        max={
          type === 'date' &&
          name === 'birthDate' &&
          moment().subtract(13, 'years').format('YYYY-MM-DD')
        }
      />
      <FieldHint
        labelBottomLeft={labelBottomLeft}
        labelBottomRight={labelBottomRight}
      />
    </div>
  )
}

export default TextInput
